import { useMutation } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import OtpInput from "react-otp-input";
import { postRequest } from "../../services/apiMethods";

const CustomerEnterOtp = ({ setFieldValue, errors, touched, values }) => {
  const [counter, setCounter] = useState(30); // 30 sec countdown
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  useEffect(() => {
    let timer;
    if (isResendDisabled && counter > 0) {
      timer = setInterval(() => {
        setCounter(prev => prev - 1);
      }, 1000);
    } else if (counter === 0) {
      setIsResendDisabled(false);
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [counter, isResendDisabled]);



  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      return postRequest("/auth/resend", data);
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200) {
        // window.location.href = `${data?.data?.url}`;
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const handleResendOTP = async () => {

    setIsResendDisabled(true);
    setCounter(30); // Reset timer

    const payload = {
    email:values?.email
    };
    mutate(payload);
  };




  return (
    <>
      <div>
        <div className="account-created-pop">

          <div className="verify-otp">

            <h6>
              We've sent a one time passcode to your email. Enter this below to continue.
            </h6>
          </div>
          <Row>
            <Col lg={12} className="mx-auto">
              <Form className="cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicPassword" >
                  <div className="form-set set-otp mt-3">


                    <OtpInput
                      value={values.otp}
                      onChange={(val) => setFieldValue("otp", val)}
                      numInputs={6}
                      isInputNum
                      inputType="tel"
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>

                  {touched.otp && errors.otp && (
                    <div className="text-danger">{errors.otp}</div>
                  )}
                </Form.Group>
                <div className="resend-otp d-flex justify-content-end">
                  <button 
                  type="button" 
                  onClick={()=>handleResendOTP()}
                    disabled={isResendDisabled}>
                    {isResendDisabled ? `Resend in ${counter}s` : "Resend OTP"}
                  </button>
                </div>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default CustomerEnterOtp;